/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserPaymentAccountRoleExtendedDto { 
    id?: number;
    insertTs?: string;
    role: UserPaymentAccountRoleExtendedDto.RoleEnum;
    acceptedOldAirtimeAgreement?: boolean;
    acceptedNewDataPlanAirtimeAgreement?: boolean;
    userAccountId?: number;
    email?: string;
    name?: string;
}
export namespace UserPaymentAccountRoleExtendedDto {
    export const RoleEnum = {
        Owner: 'OWNER',
        Viewer: 'VIEWER',
        Financial: 'FINANCIAL'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


